import type { LifeCycleDragDropEvent, StageItemProps } from '@pega/cosmos-react-build';

export interface TestData {
  event?: LifeCycleDragDropEvent;
  stages: StageItemProps[];
  alternateStages: StageItemProps[];
}

export type TypeKey = 'stage' | 'category' | 'task' | 'subTask' | 'step';

export const lifeCycleTestData: TestData = {
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStageToPrimary: TestData = {
  event: {
    type: 'stage',
    sourceData: {
      alternate: true,
      stage: 0
    },
    targetData: {
      alternate: false,
      stage: 1
    }
  },
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStageToAlternate: TestData = {
  event: {
    type: 'stage',
    sourceData: {
      alternate: false,
      stage: 0
    },
    targetData: {
      alternate: true,
      stage: 1
    }
  },
  stages: [
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStageToStart: TestData = {
  event: {
    type: 'stage',
    sourceData: {
      alternate: false,
      stage: 1
    },
    targetData: {
      alternate: false,
      stage: 0
    }
  },
  stages: [
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStageToEnd: TestData = {
  event: {
    type: 'stage',
    sourceData: {
      alternate: false,
      stage: 1
    },
    targetData: {
      alternate: false,
      stage: 3
    }
  },
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStepWithinTask: TestData = {
  event: {
    type: 'step',
    sourceData: {
      alternate: false,
      stage: 2,
      category: 0,
      task: 0,
      step: 0
    },
    targetData: {
      alternate: false,
      stage: 2,
      category: 0,
      task: 0,
      step: 1
    }
  },
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStepToParallelTask: TestData = {
  event: {
    type: 'step',
    sourceData: {
      alternate: false,
      stage: 1,
      category: 0,
      task: 1,
      subTask: 0,
      step: 0
    },
    targetData: {
      alternate: false,
      stage: 1,
      category: 0,
      task: 1,
      subTask: 1,
      step: 2
    }
  },
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStepToAlternateStage: TestData = {
  event: {
    type: 'step',
    sourceData: {
      alternate: false,
      stage: 0,
      category: 0,
      task: 0,
      subTask: 0,
      step: 0
    },
    targetData: {
      alternate: true,
      stage: 0,
      category: 0,
      task: 0,
      subTask: 0,
      step: 0
    }
  },
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: []
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataMoveStepToEmptyTask: TestData = {
  event: {
    type: 'step',
    sourceData: {
      alternate: false,
      stage: 0,
      category: 0,
      task: 0,
      subTask: 0,
      step: 2
    },
    targetData: {
      alternate: false,
      stage: 3,
      category: 0,
      task: 0,
      step: 0
    }
  },
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: [
            {
              id: '28',
              label: 'Conduct Interview',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '29',
                  label: 'HackerEarth Test',
                  visual: {
                    imgSrc: '',
                    name: 'code',
                    label: 'coding test',
                    category: 'rule',
                    inverted: true
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '30',
                  label: 'Technical 1',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '31',
                  label: 'Technical 2',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '32',
                  label: 'Technical 3',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '33',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'email',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '6',
                  label: 'Technical skills',
                  visual: {
                    imgSrc: '',
                    name: 'user-document',
                    label: 'technical',
                    category: 'task',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: []
        }
      ]
    }
  ]
};

export const lifeCycleTestDataKeyboardDragDrop: TestData = {
  stages: [
    {
      id: '1',
      label: 'Apply for job',
      type: 'start',
      error: '',
      categories: [
        {
          id: '2',
          categoryId: '',
          tasks: [
            [
              {
                id: '3',
                label: 'Collect information',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '4',
                    label: 'Personal details',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'details',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '5',
                    label: 'Work history',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'history',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '6',
                    label: 'Technical skills',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'technical',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '7',
                    label: 'Address',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'location',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '8',
                    label: 'Availability ',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'date',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '9',
                label: 'Submit application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '10',
                    label: 'Register',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'register',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '11',
                    label: 'Upload resume',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'upload',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '12',
                    label: 'Apply',
                    visual: {
                      imgSrc: '',
                      name: 'clipboard-check',
                      label: 'apply',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '13',
      label: 'Review',
      type: 'default',
      error: '',
      transitionType: 'wait',
      categories: [
        {
          id: '14',
          categoryId: '',
          tasks: [
            [
              {
                id: '15',
                label: 'Review application',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '16',
                    label: 'Review candidates for position',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'review',
                      category: 'task',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '17',
                    label: 'Contact applicants',
                    visual: {
                      imgSrc: '',
                      name: 'multi-device',
                      label: 'Channel',
                      category: 'rule',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '18',
                    label: 'Screening',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'screening',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '19',
                    label: 'Approve candidate',
                    visual: {
                      imgSrc: '',
                      name: 'check-badge',
                      label: 'approve',
                      category: 'logic',
                      inverted: true
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '20',
                label: 'Schedule Interview 1',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '21',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '22',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              },
              {
                id: '99',
                label: 'Schedule Interview 2',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '101',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '102',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ],
            [
              {
                id: '23',
                label: 'Schedule Manager Round',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '24',
                    label: 'Get Panel',
                    visual: {
                      imgSrc: '',
                      name: 'user-document',
                      label: 'get panel',
                      category: 'task',
                      inverted: false
                    },
                    status: {
                      label: 'MLP 1',
                      type: 'info'
                    },
                    error: ''
                  },
                  {
                    id: '25',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'Channel',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '26',
      label: 'Interview',
      type: 'default',
      error: '',
      categories: [
        {
          id: '27',
          categoryId: '',
          tasks: []
        }
      ]
    },
    {
      id: '34',
      label: 'Release Offer',
      type: 'default',
      error: '',
      transitionType: 'resolution',
      categories: [
        {
          id: '35',
          categoryId: '',
          tasks: [
            {
              id: '35-1',
              label: 'Release Offer',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '35-2',
                  label: 'Make a call',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'phone',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  alternateStages: [
    {
      id: '36',
      label: 'Rejected Offer',
      type: 'alternate',
      error: '',
      categories: [
        {
          id: '37',
          categoryId: '',
          tasks: [
            [
              {
                id: '38',
                label: 'Contact candidate',
                visual: {
                  imgSrc: ''
                },
                error: '',
                steps: [
                  {
                    id: '39',
                    label: 'Send Email',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'details',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  },
                  {
                    id: '40',
                    label: 'Make a call',
                    visual: {
                      imgSrc: '',
                      name: 'gear-play',
                      label: 'phone',
                      category: 'automation',
                      inverted: false
                    },
                    error: '',
                    status: {
                      label: '',
                      type: ''
                    }
                  }
                ]
              }
            ]
          ]
        }
      ]
    },
    {
      id: '41',
      label: 'Candidate unavailable',
      type: 'alternate',
      transitionType: 'resolution',
      error: '',
      categories: [
        {
          id: '42',
          categoryId: '',
          tasks: [
            {
              id: '43',
              label: 'Contact other candidates',
              visual: {
                imgSrc: ''
              },
              error: '',
              steps: [
                {
                  id: '44',
                  label: 'Send Email',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'details',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                },
                {
                  id: '45',
                  label: 'Make a call',
                  visual: {
                    imgSrc: '',
                    name: 'gear-play',
                    label: 'phone',
                    category: 'automation',
                    inverted: false
                  },
                  error: '',
                  status: {
                    label: '',
                    type: ''
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
